import { ModuleSign } from "./types";

// 绩效
export const performanceModule: ModuleSign = {
  module: "performance",
  type: "performanceBrowser",
  mListPath: '/mobile/performance/main/list',
  mDetailPath: '/mobile/performance/flow/detail/{id}',
  detailPath: '/sp/performance/flow/dealresult/detail/{id}',
  paths: [
    // 绩效
    { app: '@weapp/performance', compName: 'PerformanceViewDialog' },
    { app: '@weapp/performance', compName: 'PerformanceViewSideDialog' },
  ],
};

// 文档
export const documentModule: ModuleSign = {
  module: "doc",
  type: "document",
  mListPath: '/mobile/doc',
  mDetailPath: '/mobile/doc/docDetail/{id}',
  detailPath: '/sp/doc/docDetail/{id}',
  addPaths: [
    { app: '@weapp/doc', compName: 'DocViewDialog' },
  ],
  paths: [
    { app: '@weapp/doc', compName: 'DocViewDialog' },
    { app: '@weapp/doc', compName: 'DocViewSideDialog' },
  ],
};

// 人事详情
export const hrmProfileModule: ModuleSign = {
  module: 'hrm',
  mListPath: '',
  mDetailPath: '/mobile/hrm/profile/{id}',
  detailPath: '/sp/hrm/profileInfo/{id}',
  paths: [
    { app: '@weapp/hrm', compName: 'HrmProfileViewDialog' },
    { app: '@weapp/hrm', compName: 'HrmProfileViewSideDialog' },
  ],
};

// 考勤订阅
export const attendModule: ModuleSign = {
  module: "attend",
  paths: [
    { app: '@weapp/attend', compName: 'SubscriptDialog' },
    { app: '@weapp/attend', compName: 'SubscriptSideDialog' },
  ],
};

// 业务表单
export const formReportModule: ModuleSign = {
  module: "formdatareport",
  type: "frpt_form",
  mListPath: '/mobile/formreport',
  mDetailPath: '/mobile/formreport/datalist/{id}',
  detailPath: '/formreport/datalist/{id}',
  paths: [
    // 表单上报模块
    { app: '@weapp/formreport', compName: 'FormreportListViewDialog' },
    { app: '@weapp/formreport', compName: 'FormreportListViewDialog' },
  ],
};

// 业务表单数据
export const formDataReportModule: ModuleSign = {
  module: "formdatareport",
  type: "frpt_report",
  mListPath: '/mobile/formreport',
  mDetailPath: '/mobile/formreport/dataDetail/{id}',
  detailPath: '',
  addPaths: [
    { app: 'weapp-formreport', compName: 'FormreportNewViewDialog' },
  ],
  paths: [
    // 表单数据
    { app: '@weapp/formreport', compName: 'FormreportViewDialog' },
    { app: '@weapp/formreport', compName: 'FormreportViewSideDialog' },
  ],
};

// 报告
export const planModule: ModuleSign = {
  module: "plan", 
  type: "planBrowser",
  mListPath: '/mobile/plan/main/list',
  mDetailPath: '/mobile/plan/detail?id={id}',
  detailPath: '/sp/plan/detail/{id}',
  paths: [
    // 报告
    { app: '@weapp/plan', compName: 'PlanViewDialog' },
    { app: '@weapp/plan', compName: 'PlanViewSideDialog' },
  ],
};

/* 流程审批 */
export const workflowModule: ModuleSign = {
  module: 'workflow/core',
  type: 'wfcRequest',
  mListPath: '/mobile/workflow/index/list',
  mDetailPath: '/mobile/workflow/flowpage/view/{id}',
  detailPath: '/sp/workflow/flowpage/view/{id}',
  addPaths: [
    { app: '@weapp/workflow', compName: 'WfCLNewFlowVisibleDialog' },
  ],
  paths: [
    // 审批模块
    { app: '@weapp/workflow', compName: 'WorkflowViewDialog' },
    { app: '@weapp/workflow', compName: 'WorkflowViewSideDialog' },
  ],
};

/* ebuilder */
export const ebuilderModule: ModuleSign = {
  module: 'ebuilder/form',
  type: 'ebuilder',
  mListPath: '/mobile/ebdfpage/list/{id}',
  mDetailPath: '/mobile/ebdfpage/card/0/{id}',
  detailPath: '/sp/ebdfpage/card/0/{id}',
  addPaths: [
    { app: '@weapp/ebdfpage', compName: 'EbCardCreateDialog' },
  ],
  paths: [
    { app: '@weapp/ebdfpage', compName: 'EbCardViewDialog' },
    { app: '@weapp/ebdfpage', compName: 'EbCardViewSideDialog' },
  ],
};

/* crm 客户 */
export const customerModule: ModuleSign = {
  module: "crm",
  type: "customer",
  mListPath: '/mobile/crm/customer',
  mDetailPath: '/mobile/crm/customer/0/customerDetail/{id}',
  detailPath: '/sp/crm/customer/customerViewPage/{id}',
  addPaths: [
    { app: '@weapp/crm', compName: 'CrmCreateCustomerDialogProvider' },
  ],
  paths: [
    { app: '@weapp/crm', compName: 'CrmCustomerViewMiddleDialog' },
    { app: '@weapp/crm', compName: 'CrmCustomerViewDialogProvider' },
  ],
};
